import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Tooltip, Toast, Popover } from 'bootstrap';
import { ChatProvider } from './context/ChatContext';
// import { HelmetProvider } from 'react-helmet-async';
import { CrewAndSpaceProvider } from './context/CrewAndSpaceContext';
import { AuthProvider } from './context/AuthContext';
import { PhaseProvider } from './context/PhaseContext';
// import { HelmetProvider } from 'react-helmet-async';
document.addEventListener('DOMContentLoaded', () => {
    Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach(
        (tooltipNode) => new Tooltip(tooltipNode)
    );
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
 <AuthProvider>
    <BrowserRouter>
    <PhaseProvider>
    <CrewAndSpaceProvider>
     <ChatProvider>
       <App />
     </ChatProvider>
     </CrewAndSpaceProvider>
     </PhaseProvider>
    </BrowserRouter>
    </AuthProvider>
);